<ng-template
	#defaultItemTemplate
	let-item="item"
	let-onCollapseExpand="onCollapseExpand"
	let-onCheckedChange="onCheckedChange">
	<div class="form-inline row-item">
		<i
			*ngIf="item.children"
			(click)="onCollapseExpand()"
			aria-hidden="true"
			class="me-2 pointer fa"
			[class.fa-caret-right]="item.collapsed"
			[class.fa-caret-down]="!item.collapsed"></i>
		<label
			class="form-check-label label-text"
			[class.pointer]="!item.children"
			[class.disabled]="item.disabled"
			(click)="select(item)"
			>{{ item.text }}</label
		>
	</div>
</ng-template>

<ng-template
	#defaultHeaderTemplate
	let-config="config"
	let-item="item"
	let-onCollapseExpand="onCollapseExpand"
	let-onCheckedChange="onCheckedChange"
	let-onFilterTextChange="onFilterTextChange">
	<div *ngIf="config.hasFilter" class="d-flex">
		<input
			class="form-control"
			type="text"
			placeholder="Filtrar"
			[(ngModel)]="filterText"
			(ngModelChange)="onFilterTextChange($event)" />
	</div>
	<div *ngIf="config.hasAllCheckBox || config.hasCollapseExpand" class="row">
		<div class="col-12">
			<label
				*ngIf="config.hasCollapseExpand"
				class="pull-right"
				(click)="onCollapseExpand()">
				<i
					[title]="i18n.getTooltipCollapseExpandText(item.collapsed)"
					aria-hidden="true"
					class="fa"
					[class.fa-expand]="item.collapsed"
					[class.fa-compress]="!item.collapsed"></i>
			</label>
		</div>
	</div>
	<div *ngIf="config.hasDivider" class="dropdown-divider"></div>
</ng-template>

<div class="treeview-header">
	<ng-template
		[ngTemplateOutlet]="headerTemplate || defaultHeaderTemplate"
		[ngTemplateOutletContext]="headerTemplateContext">
	</ng-template>
</div>

<div [ngSwitch]="hasFilterItems">
	<div *ngSwitchCase="true" class="treeview-container">
		<ngx-treeview-item
			*ngFor="let item of filterItems"
			[config]="config"
			[item]="item"
			[template]="itemTemplate || defaultItemTemplate">
		</ngx-treeview-item>
	</div>
	<div *ngSwitchCase="false" class="treeview-text">
		{{ i18n.getFilterNoItemsFoundText() }}
	</div>
</div>
